module.exports = __webpack_public_path__ + "static/media/icon-popup-videocam.e8206062.svg";